export const B2B_DOMAIN = 'louis.biz';

export const DE_DOMAIN = 'louis.de';
